// extracted by mini-css-extract-plugin
module.exports = {"PaymentMethod":"PaymentMethod_rI+Jc","PaymentMethodLogo":"PaymentMethodLogo_Wn5d1"};